import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import gtag from 'vue-gtag'

import fb from './fb.js'
import './registerServiceWorker'
import store from './store'


//configure firebase
import firebase from 'firebase'

Vue.config.productionTip = false

//establish iOS Link
if (window.webkit && 'messageHandlers' in window.webkit) {
  Vue.prototype.$iosHandlers = window.webkit.messageHandlers
}
else {
  Vue.prototype.$iosHandlers = null
}

let app = null

firebase.auth().onAuthStateChanged(() => {

  if(!app) {
    app = new Vue({
      router,
      vuetify,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

})
